import {Injectable} from '@angular/core';
import ls from 'localstorage-slim';

export const PROVIDER_KEY = 'provider-id';
export const TC_KEY = 't&c';
export const FAMILY_INFO_PAGE = 'family-info';
export const SUMMARY_INFO_PAGE = 'summary-info';
export const QUOTE_INFO_PAGE = 'quote-info';
export const FNA_SUMMARY_PAGE = 'fna-summary';
export const UTM_PARAMS_KEY = 'utm_params';
export const PAGES_COMPLETED = 'pages_completed';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  setItem(key: string, value: string | Date | number | object | boolean | null, ttlInSeconds?: number) {
    ls.set(key, value, {ttl: ttlInSeconds});
  }

  getItem<T = string>(key: string): T | undefined {
    return ls.get(key) as T | undefined;
  }

  removeItem(key: string) {
    ls.remove(key);
  }

  addItem(key: string, value: string, ttlInSeconds?: number): void {
    const _values = this.getItem<string[]>(key) || [];

    if (!Array.isArray(_values)) {
      throw new Error('Value is not an array');
    }

    if (_values.includes(value)) {
      return;
    }
    _values.push(value);

    this.setItem(key, _values, ttlInSeconds);
  }
}
